import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AdminService } from '../../admin.service';
import { TicketsComponent } from '../tickets.component';
interface DialogData {}

@Component({
  selector: 'app-delete-ticket',
  templateUrl: './delete-ticket.component.html',
  styleUrls: ['./delete-ticket.component.scss']
})
export class DeleteTicketComponent implements OnInit {

  ticketData: any;

  constructor(private adminService: AdminService, private dialogRef: MatDialogRef<TicketsComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit(): void {
    this.ticketData = this.data["data"]  
  }

  deleteTicket() {
    this.adminService.deleteTicket(this.ticketData).subscribe((response:any)=>{
      this.dialogRef.close({ data: 'Confirm' }); 
    });
    
  }

  close() {
    this.dialogRef.close()
  }

}
